export default __webpack_public_path__ + "static/media/NYAH and ANRC - Joint Corr 4-14-21 for Website.cfdc602a.pdf";